/**
 * DEMO-scoped ed-hub language filter.
 *
 * Hebrew content currently lives as separate "twin" EducationContent rows
 * (same clinic, Hebrew title/artifacts) with no language field anywhere in
 * the schema. Until the real i18n content model lands (product definition
 * pending), we split the hub list by the app locale using the only signal
 * available: whether the title is written in Hebrew script.
 *
 * Throwaway by design — delete this module once content rows carry a
 * language/translations field.
 */

const HEBREW_RE = /[֐-׿]/;

export function isHebrewText(text: string): boolean {
	return HEBREW_RE.test(text);
}

/** Keep only the items matching the app locale: `he` → Hebrew-titled items,
 * anything else → non-Hebrew items. */
export function filterByLocale<T extends { title: string }>(
	items: T[],
	locale: string | undefined,
): T[] {
	const wantHebrew = !!locale && (locale === "he" || locale.startsWith("he-"));
	return items.filter((i) => isHebrewText(i.title) === wantHebrew);
}
